"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
require("./RadioButton.scss");
const RadioButton = ({ name = '', checked, onClick, onChange, value = '', id = '', children, size = 'normal', disabled = false, addClass = '', labelClass = '', dataCy, dataCyRadio }) => {
    const _onClick = (e) => {
        e.stopPropagation();
        onClick && onClick(e);
    };
    return (react_1.default.createElement("div", { className: `radio-happy5-container ${(0, classnames_1.default)(addClass)}`, ...(!disabled && onClick && { onClick: _onClick }) },
        react_1.default.createElement("input", { type: "radio", className: `state-secondary-purple
          ${size === 'small' ? ' radio-happy5-small' : ' radio-happy5'}
          ${disabled ? 'low-opacity' : ''}
        `, name: name, value: value, id: id, checked: checked, onChange: onChange, disabled: disabled, "data-cy": dataCyRadio }),
        react_1.default.createElement("label", { "data-cy": dataCy, htmlFor: id, className: disabled ? '' : 'cursor-pointer' }),
        children && (react_1.default.createElement("label", { htmlFor: id, className: `
          ${!disabled && 'cursor-pointer'} my-[0px] ${(0, classnames_1.default)(labelClass)}
          ${disabled ? 'low-opacity text-n-600' : ''}
          ` }, children))));
};
exports.default = RadioButton;
